import { useQuery } from 'react-query';
import { washHub } from 'store/slices';
import { fetchHarvestSummarys } from 'api/reports';

export const useInventoryReports = ({
  page,
  status,
  endDate,
  startDate,
  site,
  limit = 10,
  isArchived,
}: {
  page?: number;
  limit?: number;
  endDate?: Date;
  startDate?: Date;
  status?: number;
  site?: string[];
  isArchived?: boolean;
} = {}) => {
  const washHubId = washHub.selectors.useSelectedWashHubId();
  const isWashHubIdValid = washHub.selectors.useIsWashHubIdValid();
  const queryKey = [
    'fetch-reports',
    page,
    washHubId,
    site?.join(''),
    endDate,
    startDate,
    isArchived,
    status,
  ];

  const queryFn = () =>
    fetchHarvestSummarys({
      page,
      limit,
      startDate,
      endDate,
      site,
      isArchived,
      washHubId,
      status,
    });
  const options = {
    enabled: isWashHubIdValid, //!!washHubId
    keepPreviousData: true,
  };

  const { data, isFetching } = useQuery(queryKey, queryFn, options);
  const reports = data?.items || [];
  const total = data?.total || 0;
  const currentPage = data?.currentPage || 0;
  const totalPages = data?.totalPages || 0;
  return { reports, total, currentPage, totalPages, isFetching };
};
